module.exports = __webpack_public_path__ + "img/type1-2.252ca4c8.png";